import { TableBody } from "@mui/material";
import { type Ref, forwardRef } from "react";
import type { TableBodyProps as VirtuosoTableBodyProps } from "react-virtuoso";
import { useTableVirtualizedContext } from "./context";

export const VirtuosoTableBody = forwardRef(function VirtuosoTableBody(
  { children, ...props }: VirtuosoTableBodyProps,
  ref: Ref<HTMLTableSectionElement>
) {
  const { slotProps } = useTableVirtualizedContext();

  return (
    <TableBody {...props} ref={ref} {...slotProps?.tableBody}>
      {children}
    </TableBody>
  );
});
